export const usageTrendDetails = () => {
  var data = {
    Summary: [
      {
        ResourceType: "EC2",
        MonthlyUsage: [
          {
            Month: "Jan",
            Value: "100"
          },
          {
            Month: "Feb",
            Value: "100"
          },
          {
            Month: "Mar",
            Value: "102"
          },
          {
            Month: "Apr",
            Value: "103"
          },
          {
            Month: "May",
            Value: "111"
          },
          {
            Month: "Jun",
            Value: "145"
          },
          {
            Month: "Jul",
            Value: "145"
          },
          {
            Month: "Aug",
            Value: "145"
          },
          {
            Month: "Sep",
            Value: "145"
          },
          {
            Month: "Oct",
            Value: "145"
          },
          {
            Month: "Nov",
            Value: "146"
          },
          {
            Month: "Dec",
            Value: "146"
          }
        ]
      },
      {
        ResourceType: "Lambda",
        MonthlyUsage: [
          {
            Month: "Jan",
            Value: "34"
          },
          {
            Month: "Feb",
            Value: "23"
          },
          {
            Month: "Mar",
            Value: "32"
          },
          {
            Month: "Apr",
            Value: "32"
          },
          {
            Month: "May",
            Value: "33"
          },
          {
            Month: "Jun",
            Value: "65"
          },
          {
            Month: "Jul",
            Value: "68"
          },
          {
            Month: "Aug",
            Value: "78"
          },
          {
            Month: "Sep",
            Value: "77"
          },
          {
            Month: "Oct",
            Value: "45"
          },
          {
            Month: "Nov",
            Value: "45"
          },
          {
            Month: "Dec",
            Value: "45"
          }
        ]
      },
      {
        ResourceType: "ECS",
        MonthlyUsage: [
          {
            Month: "Jan",
            Value: "23"
          },
          {
            Month: "Feb",
            Value: "43"
          },
          {
            Month: "Mar",
            Value: "23"
          },
          {
            Month: "Apr",
            Value: "34"
          },
          {
            Month: "May",
            Value: "34"
          },
          {
            Month: "Jun",
            Value: "45"
          },
          {
            Month: "Jul",
            Value: "46"
          },
          {
            Month: "Aug",
            Value: "76"
          },
          {
            Month: "Sep",
            Value: "57"
          },
          {
            Month: "Oct",
            Value: "46"
          },
          {
            Month: "Nov",
            Value: "45"
          },
          {
            Month: "Dec",
            Value: "45"
          }
        ]
      },
      {
        ResourceType: "S3",
        MonthlyUsage: [
          {
            Month: "Jan",
            Value: "10"
          },
          {
            Month: "Feb",
            Value: "12"
          },
          {
            Month: "Mar",
            Value: "23"
          },
          {
            Month: "Apr",
            Value: "84"
          },
          {
            Month: "May",
            Value: "124"
          },
          {
            Month: "Jun",
            Value: "156"
          },
          {
            Month: "Jul",
            Value: "177"
          },
          {
            Month: "Aug",
            Value: "188"
          },
          {
            Month: "Sep",
            Value: "233"
          },
          {
            Month: "Oct",
            Value: "276"
          },
          {
            Month: "Nov",
            Value: "280"
          },
          {
            Month: "Dec",
            Value: "280"
          }
        ]
      },
      {
        ResourceType: "EBS",
        MonthlyUsage: [
          {
            Month: "Jan",
            Value: "2"
          },
          {
            Month: "Feb",
            Value: "3"
          },
          {
            Month: "Mar",
            Value: "3"
          },
          {
            Month: "Apr",
            Value: "7"
          },
          {
            Month: "May",
            Value: "21"
          },
          {
            Month: "Jun",
            Value: "32"
          },
          {
            Month: "Jul",
            Value: "44"
          },
          {
            Month: "Aug",
            Value: "34"
          },
          {
            Month: "Sep",
            Value: "45"
          },
          {
            Month: "Oct",
            Value: "34"
          },
          {
            Month: "Nov",
            Value: "35"
          },
          {
            Month: "Dec",
            Value: "31"
          }
        ]
      },
      {
        ResourceType: "RDS",
        MonthlyUsage: [
          {
            Month: "Jan",
            Value: "2"
          },
          {
            Month: "Feb",
            Value: "2"
          },
          {
            Month: "Mar",
            Value: "2"
          },
          {
            Month: "Apr",
            Value: "2"
          },
          {
            Month: "May",
            Value: "2"
          },
          {
            Month: "Jun",
            Value: "2"
          },
          {
            Month: "Jul",
            Value: "2"
          },
          {
            Month: "Aug",
            Value: "2"
          },
          {
            Month: "Sep",
            Value: "3"
          },
          {
            Month: "Oct",
            Value: "3"
          },
          {
            Month: "Nov",
            Value: "3"
          },
          {
            Month: "Dec",
            Value: "3"
          }
        ]
      }
    ]
  };
  return data;
};
